export default "__VITE_ASSET__CI5s3BZ6__"